module.exports = __webpack_public_path__ + "img/order_payment.6ece3599.png";